export * from './cookie-policy.component';
export * from './cookie-policy.service';
